module.exports = __webpack_public_path__ + "img/g4.fc971e34.jpg";